export const PHONE_ERROR_MESSAGE = "Informe o celular no formato 55DD9XXXXXXXX (apenas números).";

export interface PhoneValidationResult {
  normalized: string | null;
  error: string | null;
}

export function normalizePhone(input?: string | null): PhoneValidationResult {
  const raw = (input ?? "").trim();
  if (!raw) {
    return { normalized: null, error: null };
  }

  let digits = raw.replace(/\D/g, "");

  if (digits.startsWith("00")) {
    digits = digits.slice(2);
  }
  if (digits.startsWith("55")) {
    digits = digits.slice(2);
  }
  if (digits.length === 12 && digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  if (digits.length !== 11 || digits[2] !== "9") {
    return { normalized: null, error: PHONE_ERROR_MESSAGE };
  }

  return { normalized: `55${digits}`, error: null };
}
